import type { HTMLAttributes } from "react";

export default function SproutIcon(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.3149 0.657185C15.2929 0.557739 15.2031 0.48933 15.1013 0.491891C15.062 0.493247 14.1257 0.529711 12.9513 0.858488C11.3849 1.29711 10.1504 2.0538 9.38118 3.04691C8.61107 4.04121 8.2035 5.43606 8.20215 7.08091C8.20125 8.31314 8.42335 9.24148 8.43284 9.28036C8.45589 9.37529 8.54088 9.44144 8.63776 9.44144C8.64138 9.44144 8.64484 9.44129 8.64846 9.44113C8.68688 9.43918 9.60045 9.38976 10.7516 9.04788C11.8215 8.72995 13.3008 8.08806 14.2716 6.83458C15.0408 5.84147 15.4646 4.45688 15.4975 2.83067C15.5222 1.61156 15.3233 0.695708 15.3148 0.657289L15.3149 0.657185Z"
        fill="currentColor"
      />
      <path
        d="M0.873781 1.87378C0.793923 1.87378 0.749926 1.87559 0.749926 1.87559C0.64837 1.87996 0.563991 1.95605 0.549676 2.05671C0.533705 2.16956 0.174639 4.84 1.65068 6.47104C2.94242 7.89856 5.21902 8.00946 5.88603 8.00946C5.96574 8.00946 6.00973 8.00765 6.00973 8.00765C6.1137 8.00343 6.19944 7.92403 6.21104 7.82051C6.22385 7.70765 6.50637 5.03872 5.03274 3.41042C3.74235 1.9844 1.52318 1.87366 0.873762 1.87366L0.873781 1.87378Z"
        fill="currentColor"
      />
      <path
        d="M13.3482 3.93867C13.3288 3.94922 11.7628 4.79423 10.3666 6.72363C9.35151 8.12689 8.263 10.3494 8.15257 13.5083C7.94042 13.4028 7.71546 13.3248 7.4834 13.2758C7.50705 12.7704 7.55557 12.275 7.62805 11.7907C7.69887 11.3194 7.79259 10.8588 7.90951 10.409C7.91675 10.3816 7.92428 10.3537 7.93151 10.3263C8.32508 8.85269 8.96771 7.49796 9.84105 6.29887C11.3316 4.25178 12.9647 3.37771 13.0336 3.34137C13.1986 3.25443 13.4023 3.31772 13.4892 3.48271C13.576 3.64785 13.5127 3.85157 13.3482 3.93849V3.93867Z"
        fill="currentColor"
      />
      <path
        d="M7.9705 12.1186C7.81304 12.1186 7.67216 12.0078 7.63992 11.8475C6.91123 8.22266 2.65894 4.78127 2.61574 4.74694C2.47033 4.63046 2.44683 4.41801 2.5633 4.27244C2.67977 4.12704 2.89208 4.10339 3.03764 4.21986C3.08329 4.25632 4.16969 5.13038 5.36604 6.48724C6.98597 8.32445 7.97368 10.0832 8.30155 11.7143C8.33831 11.8971 8.21988 12.075 8.03711 12.1118C8.01481 12.1163 7.99236 12.1186 7.97036 12.1186L7.9705 12.1186Z"
        fill="currentColor"
      />
    </svg>
  );
}
